(function () {
  'use strict';

  const moneyFormat = window.Shopify?.currency?.active
    ? null
    : null;

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount_with_comma_separator}} €');
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateCartCount(count) {
    if (window.LimendaTutus?.updateHeaderCartCount) {
      window.LimendaTutus.updateHeaderCartCount(count);
      return;
    }
    const bubble = document.getElementById('l-header-cart-count');
    if (!bubble) return;
    bubble.dataset.value = String(count);
    let span = bubble.querySelector('span[aria-hidden="true"]');
    if (count > 0) {
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        bubble.appendChild(span);
      }
      span.textContent = count < 100 ? String(count) : '99+';
    } else if (span) {
      span.remove();
    }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  function setLoading(root, loading) {
    root.classList.toggle('is-updating', loading);
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw res;
      return res.json();
    });
  }

  function reloadCartSection() {
    const section = document.querySelector('[data-l-cart]')?.closest('.shopify-section');
    if (!section) {
      window.location.reload();
      return;
    }
    const sectionId = section.id.replace('shopify-section-', '');
    fetch(`${window.location.pathname}?section_id=${sectionId}`)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById(section.id);
        if (fresh) {
          section.innerHTML = fresh.innerHTML;
          initCart(section);
          if (window.LimendaTutus?.initScope) {
            window.LimendaTutus.initScope(section);
          }
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function changeQuantity(root, key, quantity) {
    setLoading(root, true);
    postCart('/cart/change.js', { id: key, quantity: quantity })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        reloadCartSection();
      })
      .catch(function () {
        setLoading(root, false);
        alert('Menge konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.');
      });
  }

  function updateNote(note) {
    return postCart('/cart/update.js', { note: note });
  }

  function initCart(scope) {
    const root = (scope || document).querySelector('[data-l-cart]');
    if (!root || root.dataset.lCartInit) return;
    root.dataset.lCartInit = '1';

    root.querySelectorAll('[data-l-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.lineKey;
        const input = root.querySelector(`[data-l-cart-qty-input][data-line-key="${key}"]`);
        const current = parseInt(input?.value || '1', 10);
        if (current <= 1) return;
        changeQuantity(root, key, current - 1);
      });
    });

    root.querySelectorAll('[data-l-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.lineKey;
        const input = root.querySelector(`[data-l-cart-qty-input][data-line-key="${key}"]`);
        const current = parseInt(input?.value || '1', 10);
        changeQuantity(root, key, current + 1);
      });
    });

    root.querySelectorAll('[data-l-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.lineKey;
        changeQuantity(root, key, 0);
      });
    });

    const noteField = root.querySelector('[data-l-cart-note]');
    if (noteField) {
      let noteTimer;
      noteField.addEventListener('change', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          updateNote(noteField.value).catch(function () {});
        }, 400);
      });
    }

    const discountForm = root.querySelector('[data-l-cart-discount]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const input = discountForm.querySelector('[data-l-cart-discount-input]');
        const code = (input?.value || '').trim();
        const message = root.querySelector('[data-l-cart-discount-message]');
        if (!code) return;
        if (message) {
          message.textContent = 'Rabattcode wird angewendet…';
          message.className = 'l-cart__message';
        }
        window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCart();
    });
  } else {
    initCart();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const cart = e.target.querySelector('[data-l-cart]');
    if (cart) {
      delete cart.dataset.lCartInit;
      initCart(e.target);
    }
  });
})();
